import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import ElementUI from 'element-ui';
import './assets/css/element-#FF6F28/index.css'
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/public.css'
import qs from 'qs'

// 图片预览插件
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer, {
  defaultOptions: {
    zIndex: 99999999
  }
})




import 'xe-utils'
import VXETable from 'vxe-table'
import './assets/css/vxe-theme/index.scss'
Vue.use(VXETable)
Vue.prototype.$modal = VXETable.modal

import './assets/css/common.less'
import './utils/VXERenders'
import './utils/directive'

import axios from './api/axios'
import * as echarts from 'echarts'
import api from './api'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import dayjs from 'dayjs'
import lodash from 'lodash'
import './utils/index'
Vue.use(VueCookies)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.dayjs = dayjs;
Vue.prototype._ = lodash;
Vue.use(ElementUI)
Vue.use(VueClipboard)




Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function () {
      let sign = 0
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})


if (process.env.NODE_ENV !== 'development') {
  if (location.search.includes('sid=')) {
    let query = qs.parse(location.search.replace('?', ''))
    // erp跳转同步登录态
    axios.get(`/author-login-sid`, {
      params: {
        sid: query.sid
      }
    }).then(async res => {
      if (res.data.code === 0 && res.data.data.uid) {
        localStorage.setItem('api_token', res.data.data.token)
        localStorage.setItem('uid', res.data.data.uid)
        localStorage.setItem('deviceid', res.data.data.device)
        sessionStorage.setItem('uid', res.data.data.uid)
        localStorage.setItem('name', res.data.data.name)
        localStorage.setItem('inSalesGroup', res.data.data.inSalesGroup)
        sessionStorage.setItem('name', res.data.data.name)
        sessionStorage.setItem('inSalesGroup', res.data.data.inSalesGroup)
        localStorage.setItem('gx_centername', res.data.data.centername)
        const auth = res?.data?.data?.auth || {}
        store.commit('AUTH', auth)
        localStorage.setItem('auth', JSON.stringify(auth))
        VueCookies.set("authsign",res.data.data.authsign ,'1m', null, "changwankeji.com");
        let {jumpPath = ''} = query
        router.push(decodeURIComponent(jumpPath) ||'/list')
      } else {
        ElementUI.Message({
          type: 'error',
          message: res.data.error
        })
      }
    }).finally(() => {
      router.beforeEach((to, from, next) => {
        if (to.path === '/') {
          next()
        } else {
          let name = localStorage.getItem('name')
          if (name && name !== 'null') {
            next()
          } else {
            next('/')
          }
        }
      })
    })
  } else {
    router.beforeEach((to, from, next) => {
      if (to.path === '/') {
        next()
      } else {
        let name = localStorage.getItem('name')
        if (name && name !== 'null') {
          next()
        } else {
          next('/')
        }
      }
    })

  }
}

new Vue({
  el: '#app',
  router,
  axios,
  store,
  echarts,
  render: h => h(App),
});


